export const coerceInt = (v: string): number => parseInt(v, 10);
